import { render } from "./Logos.vue?vue&type=template&id=acd6e8a8&scoped=true"
import script from "./Logos.vue?vue&type=script&lang=js"
export * from "./Logos.vue?vue&type=script&lang=js"

import "./Logos.vue?vue&type=style&index=0&id=acd6e8a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acd6e8a8"]])

export default __exports__